import React, { ReactNode } from 'react';
import styled from 'styled-components';

type ModalScreenProps = {
  title: string;
  description: string;
  children: ReactNode;
};

export const ModalScreen = ({ title, description, children }: ModalScreenProps): JSX.Element => (
  <>
    <Title>{title}</Title>

    <Description>{description}</Description>

    {children}
  </>
);

const Title = styled.h2`
  color: #47494c;
  font-size: 16px;
  font-weight: 700;
  line-height: ${20 / 16};
  margin-bottom: 4px;
  text-align: center;
  width: 100%;
`;

const Description = styled.p`
  font-size: 13px;
  line-height: ${21 / 13};
  text-align: center;
  width: 100%;
`;
